import { UserModel } from '@admin/modules/users/models/user.model';

export const mapApiResponseToUsersModels = (response: any[], tenantId: string): UserModel[] => {
    return response.map((user: any) => {
        return {
            ...user,
            collectors: user.collectors?.filter((c: any) => c.tenantId === tenantId) ?? [],
            permissions: user.extraPermissions.length > 0 //TODO: to be changed
        };
    });
};
